//SM2、SM3、SM4 加解密工具类
import smCrypto from 'sm-crypto';
import {
	Base64
} from 'js-base64';

import {
	encryptStringPrefix,
	sm2PublicKey,
	sm4Key,
} from "../plugins/keyConfig.js";

const sm2 = smCrypto.sm2;
const sm3 = smCrypto.sm3;
const sm4 = smCrypto.sm4;
const cipherMode = 0 // 1 - C1C3C2，0 - C1C2C3，默认为1

//SM2加密
function sm2encrypt(data) {
	let encryptData = encryptStringPrefix + sm2.doEncrypt(data, sm2PublicKey, cipherMode) // 加密结果
	// 加密串 进行 base64 编码
	let base64Data = Base64.encode(encryptData);
	return base64Data;
}
//SM3签名
function sm3sign(data) {
	let signData = sm3(data)
	return signData
}
//SM4解密
function sm4decrypt(data) {
	let decryptData = sm4.decrypt(data, sm4Key) // 解密结果
	return decryptData
}
//验签
function verifySign(map, signature) {
	let verifySignData = sm2.doVerifySignature(map, Base64.decode(signature),
		sm2PublicKey, {
			hash: true,
			der: true,
		},
	);
	return verifySignData
}

export default {
	sm2encrypt,
	sm3sign,
	verifySign,
	sm4decrypt
}